import React, { useEffect, useRef } from 'react';

const icons = {
  fluent: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  ),
  recipients: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  html: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  attachments: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path
        d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  ),
  static: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  templates: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <polyline points="13 2 13 9 20 9" />
    </svg>
  )
};

export const Features = () => {
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.feature-card').forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      card.style.transition = `all 0.6s ease ${index * 0.1}s`;
      observer.current.observe(card);
    });

    return () => observer.current?.disconnect();
  }, []);

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2>Everything you need</h2>
          <p>A complete toolkit for sending emails in Salesforce.</p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <div className="card-icon">{icons.fluent}</div>
            <h3>Fluent API</h3>
            <p>Chainable methods for clean, readable code. No more verbose Messaging setup.</p>
          </div>

          <div className="feature-card">
            <div className="card-icon">{icons.recipients}</div>
            <h3>Multiple Recipients</h3>
            <p>Support for TO, CC, and BCC with single or multiple addresses.</p>
          </div>

          <div className="feature-card">
            <div className="card-icon">{icons.html}</div>
            <h3>HTML & Text</h3>
            <p>Send rich HTML emails or plain text. Or both for multipart messages.</p>
          </div>

          <div className="feature-card">
            <div className="card-icon">{icons.attachments}</div>
            <h3>Attachments</h3>
            <p>Attach files from Blobs or ContentVersion records with ease.</p>
          </div>

          <div className="feature-card">
            <div className="card-icon">{icons.static}</div>
            <h3>Static Resource Templates</h3>
            <p>Use HTML templates from Static Resources with {'{{variable}}'} replacement.</p>
          </div>

          <div className="feature-card">
            <div className="card-icon">{icons.templates}</div>
            <h3>Salesforce Templates</h3>
            <p>Full support for Email Templates with merge fields.</p>
          </div>

        </div>
      </div>
    </section>
  );
};
